import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import ReactModal from 'react-modal';

import {submitAnnouncement as submit, cancelAnnouncement as cancel} from 'flows/deal/announce/index';
import {selectShowAnnouncement as selectShow, selectAnnouncementSending as selectSending} from 'flows/deal/announce/reducer'

import Spinner from 'components/Spinner';
import SendAnnouncement from './component';

export const SendAnnouncementContainer = ({show, submit, cancel, sending}) => (
  <ReactModal
    isOpen={show}
    contentLabel="Send Announcement"
    shouldCloseOnOverlayClick
    className="ReactModal"
  >
    <SendAnnouncement submit={submit} cancel={cancel} sending={sending} />
  </ReactModal>
)

SendAnnouncementContainer.propTypes = {
  show: PropTypes.bool.isRequired,
  sending: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
};

export const mapStore = store => ({
  show: selectShow(store),
  sending: selectSending(store),
});

export default connect(mapStore, {cancel, submit})(SendAnnouncementContainer);



// WEBPACK FOOTER //
// ./web/flows/deal/announce/index.js